export default "__VITE_ASSET__CHifUgze__"